module.exports = __webpack_public_path__ + "img/ctrl-swap-theta.c5701cdc.svg";